
export const LinkTypesOptions = [
  { value: "SGU_CARD", text: "SGU - Card", visibled: true },
  { value: "OUR_STORY", text: "Nossa História", visibled: true},
  { value: "COLLECTIONS", text: "Reconhecimentos", visibled: true },
  { value: "TRANSPARENCY_AND_COMMITMENT", text: "Transparência e Comprometimento", visibled: true },
  { value: "OUR_WAY_OF_CARE", text: "Nosso jeito de cuidar", visibled: true },
  { value: "PEP", text: "PEP", visibled: true },
  { value: "HUB", text: "Hub Agendamento", visibled: true },
  { value: "CLUB", text: "Meu Clube Unimed", visibled: true },
  { value: "CONNECTION", text: "Conexão Cooperado", visibled: true },
  { value: "SURGICAL_CONSENT", text: "Formulários e Termos de Consentimento Cirúrgico", visibled: true },
  { value: "RES_ELECTRONIC_HEALTH_RECORD", text: "Registro eletrônico de saúde RES", visibled: true },
  { value: "ANT_DUTS", text: "Rol de cobertura ANS + DUTS", visibled: true },
  { value: "NEW_TECNOLOGY", text: "Novas Tecnologias", visibled: true },
];

export default LinkTypesOptions;

